import * as Yup from "yup";

export const actionObject = {
  actionName: "",
  actionType: "",
  actionID: "",
};

export function objectFromFormData(formData) {
  if (formData.actionType === "675125a61b23fa51e9fab558") {
    return {
      action_type: formData.actionType,
      action_name: formData.actionName,
      params: {
        template_id: formData.templateID,
        template_name: formData.templateName,
        header_variable: formData[formData.templateName].header_variable,
        body_variable: formData[formData.templateName].body_variable,
        button_variable: formData[formData.templateName].button_variable,
      },
    };
  }

  if (formData.actionType === "675125cd1b23fa51e9fab559") {
    return {
      action_type: formData.actionType,
      action_name: formData.actionName,
      is_active: true,
      params: {
        lead_variables: formData.variables,
      },
    };
  }

  if (formData.actionType === "6763f8fe93c8acee5f29dd71") {
    return {
      action_type: formData.actionType,
      action_name: formData.actionName,
      is_active: true,
      resource_id: formData.resource,
      params: {
        url: formData.url,
        method: formData.method,
        headers: formData.headers,
        sample_payload: formData.sample_payload,
      },
    };
  }
}

export function objectFromResponseData(responseData) {
  if (responseData.action_type === "675125a61b23fa51e9fab558") {
    return {
      actionType: responseData.action_type,
      actionName: responseData.action_name,
      actionID: responseData._id,
      templateID: responseData.params.template_id,
      templateName: responseData.params.template_name,
      [responseData.params.template_name]: {
        template_id: responseData.params.template_id,
        header_variable: responseData.params.header_variable,
        body_variable: responseData.params.body_variable,
        button_variable: responseData.params.button_variable,
      },
    };
  }

  if (responseData.action_type === "675125cd1b23fa51e9fab559") {
    return {
      actionID: responseData._id,
      actionType: responseData.action_type,
      actionName: responseData.action_name,
      is_active: true,
      variables: responseData.params.lead_variables,
    };
  }

  if (responseData.action_type === "6763f8fe93c8acee5f29dd71") {
    return {
      actionType: responseData.action_type,
      actionName: responseData.action_name,
      is_active: true,
      url: responseData.params.url,
      method: responseData.params.method,
      headers: responseData.params.headers,
      sample_payload: responseData.params.sample_payload,
    };
  }
}

export function schema(val) {
  var validationSchema = Yup.object().shape({
    actionType: Yup.string().required("Action Type is required"),
    actionName: Yup.string().required("Action Name is required"),
    templateID: Yup.string().when("actionType", {
      is: (val) => val === "675125a61b23fa51e9fab558",
      then: () => Yup.string().required("Template is required"),
    }),
  });

  return validationSchema;
}
